import AdminCustomerVaspsTable from './AdminCustomerVaspsTable'

export default AdminCustomerVaspsTable
